import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '网红塌房', path: '/category/influencer-scandal' },
  { label: '明星黑料', path: '/category/celebrity-scandal' },
  { label: '博主反差', path: '/category/blogger-contrast' },
  { label: '网曝门', path: '/category/exposure-gate' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 flex-shrink-0">
            <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-heading text-xl font-bold whitespace-nowrap transition-colors duration-300 ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              51吃瓜黑料
            </span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-accent-300 bg-background-50/15'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Search + CTA */}
          <div className="hidden md:flex items-center gap-3">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 ${
                scrolled
                  ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                  : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category/exposure-gate"
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-950 hover:bg-background-100'
              }`}
            >
              快速入口
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
              scrolled
                ? 'text-foreground-950'
                : 'text-background-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200 mt-2 pt-2">
              <Link
                to="/category/exposure-gate"
                className="block w-full text-center px-4 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap"
              >
                快速入口
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}